module.exports = (__webpack_require__(7))(460);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/ng-jhipster/index.js from dll-reference vendor
// module id = 2
// module chunks = 0